export default __webpack_public_path__ + "static/media/service-2.d293ed01.jpg";